import { render, staticRenderFns } from "./BasePhotoCapture.vue?vue&type=template&id=2afbe6ba&"
import script from "./BasePhotoCapture.vue?vue&type=script&lang=js&"
export * from "./BasePhotoCapture.vue?vue&type=script&lang=js&"
import style0 from "./BasePhotoCapture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports